export enum LoaderState {
  'inactive',
  'loading',
  'error',
  'complete',
}
